<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-person"></i>
        <div class="mg-l-20">
          <h4>{{ $t("subuser.子账号管理") }}</h4>
        </div>
      </div>
      <div class="tx-right">
        <a
          v-if="isSysRights('User.addSubUserBySupplier')"
          href="javascript:;"
          class="btn btn-success mg-r-15"
          @click="addSubUserBySupplier"
          >{{ $t("subuser.新建子账号") }}</a
        >
        <a
          v-if="isSysRights('SubUser.changeByUser')"
          href="javascript:;"
          class="btn btn-primary"
          :class="{ disabled: checkArr.length == 0 }"
          @click="addSubUserGroup"
          >{{ $t("subuser.加入角色组") }}</a
        >
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30"
    >
      <div class="clear-key">
        <a
          v-show="keyName"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('keyName')"
        >
          {{ $t("subuser.姓名：") }}
          <span class="mg-r-10">{{ keyName }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-if="keyStatus"
          @click="clearKey('keyStatus')"
          href="javascript:;"
          class="mg-r-15"
        >
          {{ $t("mall.状态：")
          }}<span class="mg-r-10 tx-ellipsis1 mx-wd-lg-100 d-inline-block">{{
            keyStatus == 1 ? $t("mall.启用") : $t("mall.停用")
          }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-if="keyRoleId"
          @click="clearKey('keyRoleId')"
          href="javascript:;"
          class="mg-r-15"
        >
          {{ $t("subuser.角色组：")
          }}<span class="mg-r-10 tx-ellipsis1 mx-wd-lg-100 d-inline-block">{{
            keyRoleName
          }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    checkArr: {
      type: Array,
      default() {
        return [];
      },
    },
    keyName: String,
    keyStatus: [String, Number],
    keyRoleId: [Number, String],
    keyRoleName: String,
  },
  data() {
    return {};
  },
  methods: {
    // 新增子账号
    addSubUserBySupplier() {
      this.$parent.subUserinfo = {};
      this.$parent.subUserinfo = {
        open: Date().getTime,
        info: "",
      };
      $("#modalAddSubUserBySupplier").modal("show");
    },
    // 批量加入角色组
    addSubUserGroup() {
      $("#modalBatchRoleGroup").modal("show");
    },
    // 删除搜索记录
    clearKey(type) {
      this.$parent.filterProp[type] = "";
      if (type == "keyRoleId") {
        this.$parent.filterProp.keyRoleName = "";
      }
      this.$parent.getSubuserList();
    },
  },
};
</script>

<style>
</style>